"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = appendInlineScript;
function appendInlineScript(scriptText, parentEl) {
  // Do nothing if we're not in browser context
  if (typeof document === 'undefined') {
    return;
  }
  parentEl = parentEl || document.head || document.querySelector('head');
  var script = document.createElement('script');
  script.setAttribute('type', 'text/javascript');
  script.innerHTML = scriptText;
  parentEl.appendChild(script);
}